/**
 * PLP Pagination — numbered pages with "Next Page" link.
 */
(function () {
  const { html } = window.preact;

  function ArrowRight() {
    return html`
      <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 7h12M8 2l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
  }

  function getPageNumbers(current, total) {
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    const pages = [];
    pages.push(1);

    if (current > 3) pages.push('...');

    const start = Math.max(2, current - 1);
    const end = Math.min(total - 1, current + 1);
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (current < total - 2) pages.push('...');

    pages.push(total);
    return pages;
  }

  function Pagination({ currentPage, totalPages, onPageChange }) {
    if (totalPages <= 1) return null;

    const pages = getPageNumbers(currentPage + 1, totalPages);
    const displayPage = currentPage + 1;

    return html`
      <nav class="plp-pagination" aria-label="Pagination">
        ${pages.map((page, i) => {
          if (page === '...') {
            return html`<span key=${'dots-' + i} class="plp-pagination__dots">...</span>`;
          }
          return html`
            <button
              key=${page}
              class="plp-pagination__btn${page === displayPage ? ' plp-pagination__btn--active' : ''}"
              onClick=${() => onPageChange(page - 1)}
              aria-label="Page ${page}"
              aria-current=${page === displayPage ? 'page' : undefined}
            >
              ${page}
            </button>
          `;
        })}
        ${displayPage < totalPages && html`
          <button
            class="plp-pagination__next"
            onClick=${() => onPageChange(currentPage + 1)}
            aria-label="Next page"
          >
            <span>Next Page</span>
            <${ArrowRight} />
          </button>
        `}
      </nav>
    `;
  }

  window.PlpPagination = Pagination;
})();
